/**
 * Lazy 트리 스켈레톤 — Vue2 deep observe 비용 절감
 * String 노드 shallow freeze; children 배열은 HYDRATE 시 index 교체 가능
 */
export function freezeLazyPanelTreeSkeleton(treeData) {
  if (!treeData?.length) {
    return treeData || [];
  }
  return treeData.map(arrayNode => {
    const frozenStrings = (arrayNode.children || []).map(stringNode =>
      Object.freeze({ ...stringNode })
    );
    return Object.freeze({
      ...arrayNode,
      children: frozenStrings
    });
  });
}
